import {Pipe, PipeTransform} from '@angular/core';
import {DeviceOutput} from "../../devices/models/device_output";

@Pipe({
    name: 'outputIcon'
})
export class OutputIconPipe implements PipeTransform {

    private readonly iconPath = 'assets/icons/';
    private readonly outputIconMap: Record<string, string> = {
        'door': 'ic_door.svg',
        'gate': 'ic_gate.svg',
        'lock': 'ic_output_lock.svg',
        'light': 'ic_light.svg'
    };
    private readonly defaultIcon = 'ic_output_lock.svg';

    transform(value: DeviceOutput): string {
        if (!value?.icon) {
            return `${this.iconPath}${this.defaultIcon}`;
        }

        const outputIconName = value.icon.toLowerCase();
        const iconFileName = this.outputIconMap[outputIconName] || this.defaultIcon;

        return `${this.iconPath}${iconFileName}`;
    }

}
